/**
 * Singleton per la musica di gioco. UNA SOLA istanza Audio, mai duplicata.
 * React non crea mai Audio - solo questo modulo.
 */

import { API_ENDPOINTS } from '../api/config';

const TRACKS = [API_ENDPOINTS.GAME_MUSIC, API_ENDPOINTS.GAME_MUSIC_2];
const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let audio = null;
let currentIndex = 0;
let volume = 0.2;

function onEnded() {
  if (!audio) return;
  currentIndex = (currentIndex + 1) % TRACKS.length;
  audio.src = TRACKS[currentIndex];
  audio.play().catch(() => {});
}

function getOrCreateAudio() {
  if (audio) return audio;
  audio = new Audio(TRACKS[0]);
  audio.loop = false;
  audio.volume = isMobile() ? 1 : volume;
  audio.addEventListener('error', (e) => {
    console.warn('Background music failed to load:', e?.target?.error || 'Check backend assets');
  });
  audio.addEventListener('ended', onEnded);
  return audio;
}

export const gameMusic = {
  play(vol = volume) {
    volume = vol;
    const a = getOrCreateAudio();
    a.volume = isMobile() ? 1 : volume;
    a.play().catch(() => {});
  },

  pause() {
    if (audio) audio.pause();
  },

  setVolume(v) {
    volume = Math.max(0, Math.min(1, v));
    if (audio) audio.volume = isMobile() ? 1 : volume;
  },

  isPlaying() {
    return audio && !audio.paused;
  }
};
